const getters = {
    token: state => state.user.token,
    name: state => state.user.name,
    roles: state => state.user.roles,
    id: state => state.user.id,
    permission_routes: state => state.permission.routes,
    pageTabs: state => state.common.pageTabs,
    pageTabs_curIndex: state => state.common.curIndex,
  }
  export default getters